import { Navigate, Route, Routes } from 'react-router';
import { AanmeldPagina } from './auth/AanmeldPagina.tsx';
import { useSessie } from './auth/SessieContext.tsx';
import { UitnodigingPagina } from './auth/UitnodigingPagina.tsx';
import { VereistAanmelding } from './auth/VereistAanmelding.tsx';
import { AppSchil } from './layout/AppSchil.tsx';
import { BedrijfPagina } from './paginas/bedrijven/BedrijfPagina.tsx';
import { BedrijvenPagina } from './paginas/bedrijven/BedrijvenPagina.tsx';
import { ContactpersonenPagina } from './paginas/contactpersonen/ContactpersonenPagina.tsx';
import { CvWachtrijPagina } from './paginas/cvs/CvWachtrijPagina.tsx';
import { Dashboard } from './paginas/Dashboard.tsx';
import { GebruikersPagina } from './paginas/gebruikers/GebruikersPagina.tsx';
import { GesprekkenPagina } from './paginas/gesprekken/GesprekkenPagina.tsx';
import { KandidaatPagina } from './paginas/kandidaten/KandidaatPagina.tsx';
import { KandidatenPagina } from './paginas/kandidaten/KandidatenPagina.tsx';
import { NietGevonden } from './paginas/NietGevonden.tsx';
import { ProfielPagina } from './paginas/profiel/ProfielPagina.tsx';
import { ReferentiePagina } from './paginas/referentie/ReferentiePagina.tsx';
import { VacaturePagina } from './paginas/vacatures/VacaturePagina.tsx';
import { VacaturesPagina } from './paginas/vacatures/VacaturesPagina.tsx';
import { VoordrachtPagina } from './paginas/voordrachten/VoordrachtPagina.tsx';
import { VoordrachtenPagina } from './paginas/voordrachten/VoordrachtenPagina.tsx';

function AlleenBeheerder({ children }: { children: React.ReactElement }) {
  const { isBeheerder } = useSessie();
  return isBeheerder ? children : <Navigate to="/" replace />;
}

/**
 * De routes van de app. Alles behalve aanmelden en uitnodigingen staat achter de aanmeldcontrole.
 * @returns De routes.
 */
export function App() {
  return (
    <Routes>
      <Route path="/aanmelden" element={<AanmeldPagina />} />
      <Route path="/uitnodiging/:token" element={<UitnodigingPagina />} />
      <Route element={<VereistAanmelding />}>
        <Route element={<AppSchil />}>
          <Route index element={<Dashboard />} />
          <Route path="kandidaten" element={<KandidatenPagina />} />
          <Route path="kandidaten/:id" element={<KandidaatPagina />} />
          <Route path="vacatures" element={<VacaturesPagina />} />
          <Route path="vacatures/:id" element={<VacaturePagina />} />
          <Route path="voordrachten" element={<VoordrachtenPagina />} />
          <Route path="voordrachten/:id" element={<VoordrachtPagina />} />
          <Route path="bedrijven" element={<BedrijvenPagina />} />
          <Route path="bedrijven/:id" element={<BedrijfPagina />} />
          <Route path="contactpersonen" element={<ContactpersonenPagina />} />
          <Route path="gesprekken" element={<GesprekkenPagina />} />
          <Route path="cvs" element={<CvWachtrijPagina />} />
          <Route path="referentie" element={<ReferentiePagina />} />
          <Route
            path="gebruikers"
            element={
              <AlleenBeheerder>
                <GebruikersPagina />
              </AlleenBeheerder>
            }
          />
          <Route path="profiel" element={<ProfielPagina />} />
          <Route path="*" element={<NietGevonden />} />
        </Route>
      </Route>
    </Routes>
  );
}
